import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { SideCart } from "../SideCart/SideCart";
import { debounce } from 'lodash';
@Component
export class CartUpsell extends ThemeComponent {
    @Ref() upsellClose!: HTMLButtonElement;
    private sideCart:SideCart|null = document.body.querySelector('side-cart');

    /**
     * Initialise.
     */
    init() {
        this.setEventListeners();
    }

    /**
     * Set event listeners.
     */
    setEventListeners() {
        this.$listen(this.upsellClose, 'click', () => {
            this.classList.remove('is-active');
        });

        if (!this.sideCart) { return; }
        this.$subscribe(this.sideCart.onOpenChange, debounce(() => {
            if (!this.hasAttribute('data-enabled')) { return; }
            this.classList.add('is-active');
        }, 300));

        document.addEventListener('cartClosed', ()=> {
            this.classList.remove('is-active');
        });
    }
}
